var map = {
	"./cart.svg": "1e10",
	"./dashboard.svg": "5dac",
	"./debit.svg": "3970",
	"./default.svg": "a289",
	"./report.svg": "edc3",
	"./settings.svg": "c5e4",
	"./truck.svg": "6142",
	"./users.svg": "0f76",
	"./world.svg": "0a5d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6db5";